import React from 'react'
import { PLPFiltersTracking } from "@/components/common/Tracking";
import { useDispatch } from "react-redux";
import { setFiltersSelectedFlag } from "@/redux/actions/filtersAction";

function CustomClearRefinements({seoData}) {
  const dispatch = useDispatch();
  // function to clear filters
  const handleClearRefinements = () => {
    PLPFiltersTracking("Clear all","",false);
    dispatch(setFiltersSelectedFlag(false));
    const newUrl = seoData?.search_query ? `${location.pathname}?query=${seoData?.search_query}` : location.pathname;
    window.location.href = newUrl;
  };
  return (
    <button
      className="btn-primary-inverted black" onClick={handleClearRefinements}>
      Clear Filters
    </button>
  )
}
export default CustomClearRefinements